<template>
    <ModalEdition :isEdition="params.id != null" :modalId="'modalEditZoneStockage'" ref="modalZoneStockageRef"
        @save="saveZoneStockage">
        <div class="zoneStockage">
            <div class="form">
                <div class="form-group">
                    <label for="zoneStockage_libelle">Libellé</label>
                    <input type="text" class="form-control" id="zoneStockage_libelle" v-model="zoneStockage.libelle" />
                </div>
            </div>
        </div>
    </ModalEdition>
</template>

<script>
import Axios from '@/services/axios.service';
import ModalEdition from '../../../../components/ModalEdition.vue';

export default {
    name: 'zoneStockageEdit',
    components: {
        ModalEdition
    },
    props: {
        params: {
            type: Object,
            required: false,
            default: () => ({}),
        },

    },
    data() {
        return {
            zoneStockage: {},
            errors: [],
        }
    },
    methods: {
        getZoneStockage(id) {
            Axios.get('/zoneStockage/' + id).then(res => {
                this.zoneStockage = res.data;
            })
        },
        saveZoneStockage() {

            this.errors = []

            if (this.zoneStockage.libelle == null) {
                this.errors.push({ message: "Le libelle est requis" });
            }

            Axios.post('/zoneStockage', this.zoneStockage)
                .then(() => {
                    this.$refs.modalZoneStockageRef.closeModal();
                    this.$emit('saved');
                }).catch(err => {
                    this.errors.push({ message: 'Erreur lors de la sauvegarde de la zone de stockage:', err });
                });
        }
    },
    watch: {
        params: {
            handler(params) {
                if (params.id != null) {
                    this.getZoneStockage(params.id);
                } else {
                    this.zoneStockage = {};
                }
            },
            deep: true,
        },
    },
}
</script>

<style></style>
